/* eslint-disable security/detect-object-injection */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Message } from "../types";
import toast from "react-hot-toast";

interface ChatState {
  chats: {
    [chatId: string]: Message[]; // Each chat ID will hold its messages
  };
  activeChatId: string; // Tracks the currently active chat
  isNewChat: boolean; // Flag to indicate if the active chat is new
  isRenderSidebar:boolean;

}

const initialState: ChatState = {
  chats: {
    "1": [], // Default chat window
  },
  activeChatId: "",
  isNewChat: true,
  isRenderSidebar: false,
};

export const chatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    isNewChat: (state, action: PayloadAction<boolean>) => {
      state.isNewChat = action.payload; // Set the isNewChat flag
    },
    isRenderSidebar: (state) => {
      state.isRenderSidebar = !state.isRenderSidebar; // Toggle isRenderSidebar flag
    },
    newChats: (state) => {
      const newChatId = Date.now().toString(); // Generate unique chat ID
      state.chats[newChatId] = []; // Create a new empty chat
      state.activeChatId = newChatId; // Set the new chat as active
    },
    clearChat: (state, action: PayloadAction<string>) => {
      state.chats[action.payload] = []; // Clears the specific chat
    },
    setActiveChat: (state, action: PayloadAction<string>) => {
      state.activeChatId = action.payload; // Switch to an existing chat
    },
    sendMessages: (state, action: PayloadAction<{ chatId: string; message: Message }>) => {
      const { chatId, message } = action.payload;
      if (!state.chats[chatId]) {
        state.chats[chatId] = [];
      }
      state.chats[chatId].push(message);
    },
    
    updateMessageContent: (state, action: PayloadAction<{ chatId: string; messageId: number; content: string, context?: string }>) => {
      const { chatId, messageId, content, context } = action.payload;

      const chat = state.chats[chatId];
      if (chat) {
        const message = chat.find(msg => msg.id === messageId);
        const contextLength = chat.filter(msg => msg.context)?.length;
        if (message) {
          message.content = content;
          message.context = context;
        } else {
          if (contextLength === 8) {
            toast.error("Oops! Context memory limit reached. older questions are cleared. Feel free to continue!");
            state.chats[chatId] = chat.filter(msg => !msg.context);
          } else {
            chat.push({
              id: messageId,
              content: content,
              context: context,
            });
          }
        }
      }
    }    
    
    
  },
});

export const { sendMessages, newChats, clearChat, setActiveChat, updateMessageContent,isNewChat ,isRenderSidebar } = chatSlice.actions;
export default chatSlice.reducer;
